import Users from './components/Users';

export default Users;
